export function encodeUnicodeToBase64(str: string): string {
  const utf8Encoder = new TextEncoder();
  const utf8Bytes = utf8Encoder.encode(str);
  return btoa(String.fromCharCode(...utf8Bytes));
}
